/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
// const GenericSelectTag = ({ data, label, onChange }) => {
//   const [selectedValue, setSelectedValue] = useState('');

//   const handleValueChange = (event) => {
//     const selectedValue = event.target.value;
//     setSelectedValue(selectedValue);
//     if (onChange) {
//       onChange(selectedValue);
//     }
//   };

//   return (
//     <FormControl sx={{ width: 180 }}>
//       <Select
//         displayEmpty
//         sx={{ height: 33 }}
//         value={selectedValue}
//         onChange={handleValueChange}
//       >
//         <MenuItem value="" disabled>
//           {label}
//         </MenuItem>
//         {data.map((item, index) => (
//           <MenuItem key={index} value={item}>
//             {item}
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   );
// };

// export default GenericSelectTag;

function GenericSelectTag({ data, label, onChange, value }) {
  const [selectedValue, setSelectedValue] = useState(value ?? " ");

  const handleValueChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedValue(selectedValue);
    onChange(selectedValue);
  };

  return (
    <FormControl variant="standard" sx={{ minWidth: 150, flex: 1 }}>
      <InputLabel id="demo-simple-select-standard-label">{label}</InputLabel>
      <Select
        // displayEmpty
        sx={{ height: 33 }}
        value={selectedValue}
        onChange={handleValueChange}
      >
        <MenuItem value={label}>{/* {label} */}</MenuItem>
        {data.map((item, index) => (
          <MenuItem key={index} value={item}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default GenericSelectTag;
